import React, { useEffect, useState } from 'react';
import { API_BASE_URL } from '../config';
import { useNavigate } from 'react-router-dom';

const HallTicket: React.FC = () => {
  const [ticket, setTicket] = useState<any>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      navigate('/login');
      return;
    }

    fetch(`${API_BASE_URL}/contest/hall-ticket`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.ticket) {
          setTicket(data.ticket);
        } else {
          navigate('/settings');
        }
      })
      .catch(() => navigate('/settings'));
  }, [navigate]);

  if (!ticket) {
    return (
      <div className="flex items-center justify-center min-h-screen text-gray-500">
        Loading Hall Ticket...
      </div>
    );
  }

  const formattedDate = new Date(ticket.contest_date).toLocaleString('en-IN', {
    dateStyle: 'full',
    timeStyle: 'short',
  });

  return (
    <div className="max-w-3xl mx-auto mt-24 px-6 print:px-0 print:mt-0">
      <div className="bg-white border shadow-lg rounded-lg p-8 print:border-0 print:shadow-none">
        <div className="text-center border-b pb-4 mb-6">
          <h1 className="text-3xl font-bold text-indigo-700">🎫 Quizora Hall Ticket</h1>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-gray-800">
          <div>
            <p><span className="font-semibold">Hall Ticket No:</span> {ticket.hall_ticket_no}</p>
            <p><span className="font-semibold">Full Name:</span> {ticket.username}</p>
            <p><span className="font-semibold">Email:</span> {ticket.email}</p>
            <p><span className="font-semibold">Mobile:</span> {ticket.mobile}</p>
          </div>

          <div>
            <p><span className="font-semibold">Contest:</span> {ticket.contest_name}</p>
            <p><span className="font-semibold">Date:</span> {formattedDate}</p>
            <p><span className="font-semibold">Reward:</span> {ticket.reward} (₹{ticket.reward_worth})</p>
          </div>

          <div className="col-span-1 md:col-span-2 flex justify-center mt-4">
            <div className="flex flex-col items-center">
              <img
                src={ticket.qr_url}
                alt="QR Code"
                className="w-40 h-40 border rounded"
              />
              <span className="mt-2 text-xs text-gray-500">Scan for verification</span>
            </div>
          </div>
        </div>

        <div className="text-right mt-8 print:hidden">
          <button
            onClick={() => window.print()}
            className="bg-indigo-600 hover:bg-indigo-700 text-white font-medium px-6 py-2 rounded"
          >
            🖨️ Print Ticket
          </button>
        </div>
      </div>
    </div>
  );
};

export default HallTicket;
